import { Box } from '@jfs/ui-new'
import { TextInputWithLabelOnBorder } from '../../../comps/TextInputWithLabelOnBorder'

export const TextInputWithLabelOnBorderWrapper = (props: any) => {
  return (
    <Box marginVertical={16}>
      <TextInputWithLabelOnBorder {...props} />
    </Box>
  )
}
